import { type Stacklet } from '@/entities/stacklet';
import request from '@/shared/api/request';

export const detachFirewallFromStacklet = (
  id: number,
  firewall_uuid: string,
): Promise<{ stacklet: Stacklet }> =>
  request({
    url: `/stacklets/${id}/`,
    method: 'POST',
    data: { action: 'firewall_detach', firewall_uuid },
  });
